import CustomerSimpleForm from './CustomerSimpleForm'

export default CustomerSimpleForm
